import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography,
  Box, Checkbox, FormControlLabel, Alert, CircularProgress, Divider
} from '@mui/material';
import PolicyIcon from '@mui/icons-material/Policy';
import { apiFetch } from '../../api/client';
import { withUnidade } from '../../utils/storageByUnit';

export default function LgpdConsentimentoDialog({ open, politicasPendentes, unidadeSelecionada, onAceito, onClose }) {
  const [aceitos, setAceitos] = useState({});
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const [expandida, setExpandida] = useState(null);

  const todosMarcados = politicasPendentes?.length > 0 &&
    politicasPendentes.every((p) => aceitos[p.id]);

  const handleConfirmar = async () => {
    if (!todosMarcados) return;
    setLoading(true);
    setErro('');
    try {
      const res = await apiFetch(withUnidade('/api/lgpd/consentimentos', unidadeSelecionada), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ politica_ids: politicasPendentes.map((p) => p.id) })
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || 'Erro ao registrar aceite');
      }
      onAceito?.();
    } catch (e) {
      setErro(e.message);
    } finally {
      setLoading(false);
    }
  };

  if (!politicasPendentes?.length) return null;

  return (
    <Dialog open={open} maxWidth="md" fullWidth disableEscapeKeyDown>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <PolicyIcon color="primary" />
          Aceite das Políticas de Privacidade (LGPD)
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" mb={2}>
          Para continuar utilizando o sistema, leia e aceite as políticas vigentes da sua unidade.
          Seus aceites são registrados com data, hora e identificação para fins de auditoria.
        </Typography>
        {erro && <Alert severity="error" sx={{ mb: 2 }}>{erro}</Alert>}
        {politicasPendentes.map((p) => (
          <Box key={p.id} mb={2}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={!!aceitos[p.id]}
                  onChange={(e) => setAceitos({ ...aceitos, [p.id]: e.target.checked })}
                />
              }
              label={
                <Typography fontWeight={600}>
                  {p.titulo} <Typography component="span" variant="caption">(v{p.versao})</Typography>
                </Typography>
              }
            />
            <Button size="small" onClick={() => setExpandida(expandida === p.id ? null : p.id)}>
              {expandida === p.id ? 'Ocultar texto' : 'Ler texto completo'}
            </Button>
            {expandida === p.id && (
              <Typography component="pre" sx={{ mt: 1, p: 1.5, bgcolor: 'grey.50', borderRadius: 1, whiteSpace: 'pre-wrap', fontSize: 13, maxHeight: 200, overflow: 'auto' }}>
                {p.conteudo}
              </Typography>
            )}
            <Divider sx={{ mt: 1 }} />
          </Box>
        ))}
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose} color="inherit" disabled={loading}>Sair</Button>
        <Button variant="contained" onClick={handleConfirmar} disabled={!todosMarcados || loading}>
          {loading ? <CircularProgress size={22} /> : 'Aceitar e continuar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
